import { decode } from 'html-entities'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'srcReact/SearchPage/components/styles.module.scss'
import { useTranslation } from 'react-i18next'
import {
  getContentWithHighlightedText,
  getHighlightedSearchContent,
  matchedSearchInterestsInArray,
  getIconNameFromExtension
} from 'srcReact/helpers/utils'
import FileNavigationPopup from 'srcReact/components/common2/FileNavigationPopup'
import MediaImage from 'srcReact/components/common2/MediaImage'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'
import IconButton from 'srcReact/components/common2/IconButton'
import { isFileImage } from 'srcReact/helpers/fileHelper'
import AnchorLink from 'srcReact/components/common2/AnchorLink'

const Media = ({ id, scope, isMobile, isNative, isHeader = false, infiniteScrollRef, isBackNavigation }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    globalSearch: {
      searchInterestText,
      media,
      media_posts: { results }
    }
  } = useSelector((state) => state)
  const [isImageOpen, setIsImageOpen] = useState(false)
  const [image, setImage] = useState(null)

  const showImageModal = (img) => {
    setIsImageOpen(true)
    setImage(img)
  }

  const closeImageModal = () => {
    setIsImageOpen(false)
  }

  const handleMediaClick = (m) => {
    const findMediaPost = results?.find((mp) => mp.id === m.post_id)
    if (findMediaPost) {
      window.location = findMediaPost.url
    }
  }

  let searchedMedia = media
  if (scope === 'all') {
    searchedMedia = media.filter((m) => m.id === id)
  }

  return (
    <div className={styles.searchContentWrapper}>
      {searchedMedia?.length > 0 &&
        searchedMedia.map((m, i) => {
          const extension = m.name.split('.').pop()
          const isImage = isFileImage(m)
          const findMediaPost = results?.find((mp) => mp.id === m.post_id)
          return (
            <AnchorLink
              aria-label={
                isImage
                  ? t('globalSearch.accessibility.imageName', { fileName: m.name })
                  : t('globalSearch.accessibility.documentName', { fileName: m.name })
              }
              className={`${styles.searchContent} ${(isHeader || isMobile) && styles.headerContentWrapper}`}
              key={i}
              ref={infiniteScrollRef}
              onMouseDown={(e) => e.preventDefault()}
              {...(findMediaPost ? { path: findMediaPost.url, isReactLink: false } : {})}>
              <div className={`${styles.picture} ${styles.isMedia}`}>
                {isImage ? (
                  <MediaImage
                    key={`${m.id}_${i}`}
                    file={m}
                    files={media}
                    index={i}
                    showPlainImageModal={() => handleMediaClick(m)}
                  />
                ) : (
                  <TooltipWrapper
                    triggerElement={
                      <IconButton iconSize='large32' iconName={extension && getIconNameFromExtension(extension)} />
                    }
                    content={media.name}
                  />
                )}
              </div>
              <div className={styles.heading}>
                <div className={styles.titleInterests}>
                  <div
                    className={styles.title}
                    dangerouslySetInnerHTML={{
                      __html: getContentWithHighlightedText(`${decode(m.name)}`, searchInterestText)
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getHighlightedSearchContent(
                        `${decode(m.name)}`,
                        matchedSearchInterestsInArray(m.interests, searchInterestText)
                      )
                    }}
                  />
                </div>
              </div>
            </AnchorLink>
          )
        })}
      {isImageOpen && image && (
        <FileNavigationPopup
          isOpen={isImageOpen}
          file={image}
          fileIndex={-1}
          files={null}
          closeModal={closeImageModal}
          loggedInUserId={loggedInUser.id}
          enableDeleteFile={false}
          plain={true}
        />
      )}
    </div>
  )
}

export default Media
